import { render, staticRenderFns } from "./titleDetailInfoRow.vue?vue&type=template&id=bd3c165c&scoped=true"
import script from "./titleDetailInfoRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./titleDetailInfoRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./titleDetailInfoRow.vue?vue&type=style&index=0&id=bd3c165c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3c165c",
  null
  
)

export default component.exports